module.exports = __webpack_public_path__ + "media/src/images/certificates/generic_audit_sample-17d28fb57308b1bea594205296214eaa.jpg";